"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLabBeakerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.018 5h1.964v4.493c0 .666.163 1.32.475 1.905h-2.913c.31-.585.474-1.24.474-1.905V5zM8 4c0-1.037 1-1 1-1h5.947S16 3 16 4s-1.053 1-1.053 1v4.493c0 .333.081.66.237.953l4.576 7.602C20.47 19.38 19.521 21 18.033 21H5.967c-1.488 0-2.436-1.62-1.727-2.952l4.576-7.602c.156-.293.237-.62.237-.953V5S8 5 8 4zm6 9h-4l-4 6h12l-4-6z' }))); };
exports.default = SvgLabBeakerOutline;
//# sourceMappingURL=LabBeakerOutline.js.map